import { API_AUTH } from "./common";
const GoiPhanMemApi = {
    GoiPhanMemNoPhaiThu: () => API_AUTH.get(`quan-ly-cua-hang/no-phai-thu-theo-goi`, {}),
    GoiPhanMemCamDo: () => API_AUTH.get(`quan-ly-cua-hang/cam-do-theo-goi`, {}),
    GoiPhanMemHienThiMenu: () => API_AUTH.get(`quan-ly-cua-hang/menu-theo-goi`, {}),
    GoiPhanMemHienTai: () => API_AUTH.get(`goiphanmem`, {}),

  };
  
  export default GoiPhanMemApi;
  